export default "/images/feecc6e6f5cd0411b468fdb87879c5fa.avif";